/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ScheduleType } from "./types";

export const scheduleTypeOptions = [
  {
    name: "Recurring",
    label: "Define the timing and frequency for executing the plan.",
    value: ScheduleType.recurring,
  },
  {
    name: "Specified dates",
    label: "The plan will run at the specified dates and times.",
    value: ScheduleType.specifiedDates,
  },
  {
    name: "On Demand",
    label: "The plan can be manually initiated as needed.",
    value: ScheduleType.onDemand,
  },
];

export const baselineStrings = {
  baselineInfo:
    "Baseline patching allows to install exactly the same update patches on many environments.",
  baselineDisabledDropdownInfo: `Certain settings for this action are defined by the Baseline source. To set this action as the Baseline, first disable the current Baseline source.`,
  baselineDisabledDropdownInfoMultipleActions:
    "Baseline patching is disabled for this action, because there's more than one PATCH or SCAN action in the batch. To set this action as the Baseline, first remove the other PATCH or SCAN actions from the batch.",
  confirmationModalEnable:
    "You are setting this action as the Baseline source. Once enabled, some advanced settings will be inherited by PATCH and SCAN actions following the Baseline source. Disabling the baseline will not restore previous settings. Are you sure you want to proceed?",
  confirmationModalDisable:
    "You are about to disable this action as the Baseline source. As a result, some advanced settings of PATCH and SCAN actions following the Baseline source will no longer be inherited and will need to be configured manually. Are you sure you want to proceed?",
  cannotDragModalWarning:
    "Cannot change the order of actions. To change the order of the baseline source and subsequent actions, you must first disable Baseline Patching. The dependent actions following the source must remain consistent with the baseline configuration. Do you want to disable Baseline Patching?",
  singleBaselineActionWarning:
    "Baseline Patching requires at least one dependent action (SCAN or PATCH) directly below the Baseline Source action in the plan actions list. Please add or rearrange actions to meet this requirement.",
};
